var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { LoadingButton } from '@mui/lab';
import { Button, Link, Stack, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { ACTUAL_ROUTER_URL } from '../../router/constants';
var StyledManageSettingsButton = styled(Button)(function (_a) {
  var theme = _a.theme;
  return {
    fontSize: theme.typography.pxToRem(16),
    fontWeight: 400,
    width: 'max-content',
    '&:hover': {
      backgroundColor: 'transparent',
      opacity: 1
    },
    '&:disabled': {
      color: theme.palette.text.disabled,
      border: 'none'
    },
    textDecoration: 'underline'
  };
});
var StyledDownloadLink = styled(Link)(function (_a) {
  var theme = _a.theme;
  return {
    color: theme.palette.primary.main,
    '&:hover': {
      textDecoration: 'underline'
    },
    '&:disabled': {
      color: theme.palette.grey[600],
      textDecorationColor: theme.palette.grey[600],
      opacity: 1
    }
  };
});
export var ControlPanelHeader = function () {
  var t = useTranslation('report').t;
  var location = useLocation();
  var navigate = useNavigate();
  var isOnSettingsPage = location.pathname.includes(ACTUAL_ROUTER_URL.Settings);
  var handleClickSettings = function () {
    navigate(ACTUAL_ROUTER_URL.Settings);
  };
  return _jsxs(Stack, __assign({
    direction: "row",
    alignItems: "center",
    justifyContent: "space-between",
    spacing: "0.5rem"
  }, {
    children: [_jsxs(Typography, __assign({
      component: "span"
    }, {
      children: [_jsx(Typography, __assign({
        component: "span"
      }, {
        children: t('actual.description')
      })), _jsxs(Typography, __assign({
        color: function (theme) {
          return theme.palette.grey[600];
        },
        component: "span",
        display: "none"
      }, {
        children: [t('actual.caption'), _jsx(StyledDownloadLink, __assign({
          component: "button",
          disabled: true
        }, {
          children: t('actual.downloadTemplate')
        }))]
      }))]
    })), _jsxs(Stack, __assign({
      direction: "row",
      alignItems: "center",
      spacing: "1.25rem"
    }, {
      children: [_jsx(StyledManageSettingsButton, __assign({
        disabled: isOnSettingsPage,
        onClick: handleClickSettings
      }, {
        children: t('actual.manageSettings.title')
      })), _jsx(LoadingButton, __assign({
        variant: "outlined",
        sx: {
          minWidth: '6.25rem',
          display: 'none'
        },
        disabled: true
      }, {
        children: t('actual.upload')
      }))]
    }))]
  }));
};